import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import App from './App';
import './index.css';
import rootReducer from './reducers';
import * as serviceWorker from './serviceWorker';

// import CostCalc from "./pages/costcalc"
const store = createStore(rootReducer)

const render = () => ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
  ,
  document.getElementById("root")
);

if (document.getElementById('root')) {
  serviceWorker.unregister();
  render()
  store.subscribe(render)
}

if (document.getElementById('calculator')){
  const CostCalc = React.lazy(() => import('./pages/costcalc'));
  ReactDOM.render(
    <Suspense fallback={<div>Loading...</div>}>
    <CostCalc />
    </Suspense>,
    document.getElementById('calculator')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
